<template>
    <div class="shop-info-box">
        <div class="shop__content" v-if="hasInfo">
            <slot name="info-area" />
        </div>
        <div class="shop__cta-area" v-if="hasCta">
            <slot name="cta-area" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "shop-info-box",
        computed: {
            hasCta() {
                return !!this.$slots["cta-area"]
            },
            hasInfo() {
                return !!this.$slots["info-area"]
            }
        }
    }
</script>

